import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();

  @HostBinding('class.is-fixed') isFixed = false;

  private routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.checkRoute(this.router.url);
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.checkRoute((e as NavigationEnd).urlAfterRedirects);
      });
  }

  private checkRoute(url: string) {
    this.isFixed =
      url.startsWith('/bar/') ||
      url.startsWith('/lists/');
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }
}
